import React, { useState } from "react";
import styled from "styled-components";
import DiscussionList from "./DiscussionList";
import DiscussionProfile from "./DiscussionProfile";
import Button from "../Button";
import DiscussionFilters from "./DiscussionFilters";
import DiscussionHeader from "./DiscussionHeader";
import SupplyChainLegendItem from "../baitToPlate/BaitToPlateLegendItem";

/*
<a href={withPrefix(`/methodology/#method-discussion`)} target="_blank" relf="noopener noreferrer" title="Methodology"><span>Methodology</span> 
*/


const DiscussionInterior = ({ entity, getEntityHash, getEntityTitle, entities, entityHasFlag  }) => {

  const [filteredItems, setFilteredItems] = useState(entities);

  const [filtersOpenMobile, setFiltersOpenMobile] = useState(false);

  return (
    <>
      <DiscussionHeader
        title="Discussion"
        getEntityHash={getEntityHash}
        getEntityTitle={getEntityTitle}
        entity={entity}
        searchIndex={entities}
      />
      <StyledDiscussionInterior>
        <div className="filters">
          <DiscussionFilters
            getEntityHash={getEntityHash}
            getEntityTitle={getEntityTitle}
            entity={entity}
            items={entities}
            filteredItems={filteredItems}
            setFilteredItems={setFilteredItems}
            filtersOpenMobile={filtersOpenMobile}
            setFiltersOpenMobile={setFiltersOpenMobile}
            entityHasFlag={entityHasFlag}
          />
        </div>

          { ! entity && (
            <div className="list">
              <StyledDiscussionListHeader>
                <h1>Stakeholders</h1>
                <h2>Companies, organizations & agencies tied to the global seafood market</h2>
                <Button as="button" type="button" className="is-small" onClick={() => setFiltersOpenMobile( ! filtersOpenMobile )}>Filter</Button>
              </StyledDiscussionListHeader>
              <SupplyChainEntityTypeOverviewStats>
                <div className="title">Of {entities.length} stakeholders contacted, at least:</div>
                <div className="stats">
                  <SupplyChainLegendItem type="uyghur-labor" text={entities.filter((item, index) => entityHasFlag(item, "uyghur-labor") ).length} caveat={true} />
                  <SupplyChainLegendItem type="north-korean-labor" text={entities.filter((item, index) => entityHasFlag(item, "north-korean-labor") ).length} caveat={true} />
                  <SupplyChainLegendItem type="human-rights" text={entities.filter((item, index) => entityHasFlag(item, "human-rights") ).length} caveat={true} />
                  <SupplyChainLegendItem type="environmental" text={entities.filter((item, index) => entityHasFlag(item, "environmental") ).length} caveat={true} />
                </div>
              </SupplyChainEntityTypeOverviewStats>
              <DiscussionList
                items={filteredItems}
                getEntityHash={getEntityHash}
                getEntityTitle={getEntityTitle}
              />
            </div>
          
          )}
          {entity && (
            <div className="entity">
              <DiscussionProfile 
                entity={entity} 
              />
            </div>
          )}

      </StyledDiscussionInterior>
    </>
  )
};

export default DiscussionInterior;

const SupplyChainEntityTypeOverviewStats = styled.div`
  position: relative;
  z-index: 11;
  background-color: #191919;
  padding: 1em;
  border-radius: 1em;
  margin: 1.5em 0;
  .title {
    font-weight: 700;
    display: block;
    font-size: 0.875em;
    margin-bottom: 0.5em;
    @media ( min-width: 48em ) {
      font-size: 1em;
    }
  }
  .stats {
    display: grid;
    gap: 0.5em 1em;
    @media ( min-width: 48em ) {
      grid-template: auto / 1fr 1fr;
    }
  }
`;


const StyledDiscussionListHeader = styled.header`
  position: relative;
  display: flex;
  align-items: baseline;
  //border-bottom: 1px solid;
  z-index: 12;
  transform: translate3d(0,0,0);
  background-color: var(--color-black);
  padding: 1em 0;
  @media ( max-width: 70em ) {
    position: sticky;
    top: calc(var(--navbar-height) + 43px);
    gap: 0.5em;
    margin: 2em 0 1em;
    padding: 0.625em 0 0.5em;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255,255,255,0.5);
    h2 {
      display: none;
    }
    button {
      transform: translate3d(0,-0.125em,0);
    }
  }
  @media ( min-width: 70em ) {
    button {
      display: none;
    }
  }
  /*@media ( min-width: 48em ) {
    display: grid;
    grid-template: 1fr / 6em 1fr;
    align-items: center;
    gap: 1.5em;
  }*/
  
  h1 {
    font-size: 1.5em;
    font-weight: 700;
    margin: 0;
    line-height: 1;
  }
  h2 {
    font-size: 1em;
    font-weight: 500;
    margin: 0;
    line-height: 1.3;
  }

  @media ( min-width: 70em ) {
    padding-top: 2em;
    h1 {
      font-size: 2em;
    }
    h2 {
      font-size: 1.125em;
      &::before {
        content: "-";
        margin: 0 0.5em;
      }
    }
  }
`;

const StyledDiscussionInterior = styled.div`
  padding-bottom: 3em;
  @media ( max-width: 70em ) {
    padding-bottom: calc(81px + 1.5em);
  }
  @media ( min-width: 70em ) {
    display: grid;
    grid-template: auto / 26em 1fr;
    gap: 3em;
    min-height: calc(100vh - (var(--navbar-height) + 77px)); 
    grid-template: auto / 38em  1fr 14em;
    grid-template: auto / 25em 13em  1fr 13em;

    grid-template: auto / repeat(8, 1fr);
    .filters {
      grid-column: 1 / span 2;
      grid-row: 1;
    }
    .list {
      grid-column: 3 / span 6;
      grid-row: 1;
    }

    .entity {
      grid-column: 3 / span 6;
      grid-row: 1;
    }
  }
  @media ( min-width: 80em ) {

    .entity {
      grid-column: 3 / span 6;
      grid-row: 1;
    }
  }
`;